<template>
  <v-app>
    <v-main class="pa-10 pb-2 black">
      <div :class="isLandscape?'d-flex':''">
        <div  class="mb-5" style="overflow-y: hidden;" :style="isLandscape?'width:50%;height:92vh;':'width:100%;height: 47vh;'" id="served">
          <h1 class="mb-5 ml-3 font-weight-bold display-2 white--text">
            Bestellung abholbereit
          </h1>
          <div class="d-flex flex-wrap" >
            <template v-for="(order,index) in servedOrders" >
              <v-slide-x-transition hide-on-leave :key="index">
                <Order  :key="order.id" :ratio="servedRatio" :order="order" :index="index" :isServed="true" @removeOrder="removeOrder"></Order>
              </v-slide-x-transition>
            </template>
          </div>
        </div>
        <v-divider :vertical="isLandscape"/>
        <div style="overflow-y: hidden;" :style="isLandscape?'width:50%;height:92vh;':'width:100%;height: 47vh;'" id="prepared">
          <h1 class="mb-5 ml-3 font-weight-bold display-2 white--text">
            In Zubereitung
          </h1>
          <div class="d-flex flex-wrap" >
            <template v-for="(order,index) in prepareOrders" >

              <v-slide-x-reverse-transition hide-on-leave :key="index">
              <Order  :key="order.id" :ratio="preparedRatio" :order="order" :index="index" :isServed="false"></Order>
              </v-slide-x-reverse-transition>
            </template>
          </div>
        </div>
      </div>
      <AuthDialog v-if="isAuth"/>
      <v-dialog :value="errorMessage.length > 0" persistent max-width="500">
        <v-card color="error" dark>
          <v-card-text
            class="text-center"
            style="padding-top: 30px; font-weight: bold; color:white; padding-bottom: 30px; font-size: 20px;"
          >
            {{ errorMessage }}
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-main>
  </v-app>
</template>

<script>
//import Vue from "vue";
import Order from "./components/Order";
import {mapGetters} from 'vuex';
import AuthDialog from "./components/AuthDialog";

export default {
  name: "App",
  components: {AuthDialog, Order },

  data: () => ({
    errorMessage: "",

    orders: [],

    servedTimers: [],
    servedDims:{
      width:200+16,
      height:140+16,
    },
    preparedDims:{
      width:150+16,
      height:100+16,
    },
    /*prepareOrders: [],*/
  }),

  computed: {
    ...mapGetters({
      bs:'bs',
      bsid:'bsid',
      socketServer:'socketServer',
    }),
    isAuth(){
      return (!this.bs || !this.bsid) && process.env.VUE_APP_ANDROID_APP === 'true'
    },
    isLandscape(){
      return this.$vuetify.breakpoint.width>this.$vuetify.breakpoint.height
    },
    servedRatio(){
      let width =document.getElementById("served").clientWidth;
      let height =document.getElementById("served").clientHeight;
      let rows =Math.floor(height/this.servedDims.height);
      let cols =Math.floor(width/this.servedDims.width);
      let maxOrders = rows*cols;
      let ratio = maxOrders/this.servedOrders.length;
      return ratio>1?1:ratio;
    },
    preparedRatio(){
      let width =document.getElementById("prepared").clientWidth;
      let height =document.getElementById("prepared").clientHeight;
      let rows =Math.floor(height/this.preparedDims.height);
      let cols =Math.floor(width/this.preparedDims.width);
      let maxOrders = rows*cols;
      let ratio = maxOrders/this.prepareOrders.length;
      return ratio>1?1:ratio;
    },
    servedOrders() {
      var servedOrders = [];

      this.orders.forEach((order) => {

        if (Number(order.status) === 1 && (order.pickUpNumber && order.pickUpNumber!=='')) {
          servedOrders.push(order);
        }
      });

      return servedOrders.sort(function(a, b){
        return (Number(b.pickUpNumber)?Number(b.pickUpNumber):0) - (Number(a.pickUpNumber)?Number(a.pickUpNumber):0)
      });
    },
    prepareOrders() {
      var prepareOrders = [];

      this.orders.forEach((order) => {
        if ((Number(order.status) === 2 || Number(order.status) === 0) &&(order.pickUpNumber && order.pickUpNumber!=='')) {
          prepareOrders.push(order);
        }
      });


      return prepareOrders.sort(function(a, b){
        return (Number(b.pickUpNumber)?Number(b.pickUpNumber):0) - (Number(a.pickUpNumber)?Number(a.pickUpNumber):0)
      });
    },
  },
  methods: {
    canShowOrder(order){
      // CHECK IF THE ORDER HAVE ANY ITEMS THAT ARE ASSIGNED TO A KITCHEN MONITOR
      return order.items.some(item=> {
        return item.kitchenMonitors?.length>0 || item.kitchenMonitors2?.length>0 || item.kitchenmonitorId?.length>0
      })
    },
    removeOrder(order){
      let orderIndex=this.orders.indexOf(order);
      if(orderIndex>-1){
        this.orders.splice(orderIndex,1);
      }
    },
    serveAll(payload) {
      const order = this.orders.find((order) => order.id === payload.id);

      if (order && this.canShowOrder(order)) {
        order.status = 1;
        this.servedTimers.push({order:order,time:Date.now()})
      }

      /*this.orders.forEach((order) => {
        if (order.status == 1) {
          const served = this.servedOrders.find(
            (servedOrder) => servedOrder.id == order.id
          );

          if (!served) {
            this.servedOrders.push(order);

            let itemIndex = this.prepareOrders.indexOf(order);
            Vue.delete(this.prepareOrders, itemIndex);
          }
        }
      });*/
    },
    prepareAll(payload) {
      const order = this.orders.find((order) => order.id === payload.id);

      if (order) {
        order.status = 2;
      }
    },
  },

  sockets: {
    "kitchenmonitor.addOrder": function(payload) {

      if (payload.order && this.canShowOrder(payload.order)) {

        if(payload.order.items.length===0){
          payload.order.status=1;
          this.servedTimers.push({order:payload.order,time:Date.now()})
        }
        this.orders.push(payload.order)
      }
    },
    "kitchenmonitor.refreshOrders": function () {
      this.$socket.emit("pickupMonitor.refreshOrders");
    },
    "pickupMonitor.initOrders": function(payload) {
      if (payload.success) {
        if (payload.orders.length > 0) {
          this.orders = payload.orders.filter(order=> {
            return this.canShowOrder(order)
          });
        } else {
          this.orders = [];
        }
      }
    },
    "kitchenmonitor.serveItem": function(payload) {
      const orderIndex = this.orders.findIndex((order) => order.id === payload.order.id);

      if (orderIndex!==-1) {
        const itemIndex = this.orders[orderIndex].items.findIndex((item) => item.id === payload.item.id);

        if (itemIndex!==-1) {
          this.orders[orderIndex].items[itemIndex].status = 1;
          this.orders[orderIndex].items[itemIndex].selected = false;
        }

        //CHECK IF ALL ITEMS ARE SERVED
        const unservedItem = this.orders[orderIndex].items.find(
          (item) => item.status === 0 || item.status === 2
        );

        if (!unservedItem) {
          this.serveAll(this.orders[orderIndex]);
        }
      }
    },
    "kitchenmonitor.serveAll": function(payload) {
      const orderIndex = this.orders.findIndex((order) => order.id === payload.order.id);

      if (orderIndex!==-1) {
        this.serveAll(this.orders[orderIndex]);
      }
    },
    "kitchenmonitor.prepareItem": function(payload) {
      const orderIndex = this.orders.findIndex((order) => order.id === payload.order.id);

      if (orderIndex!==-1) {
        const itemIndex = this.orders[orderIndex].items.findIndex((item) => item.id === payload.item.id);

        if (itemIndex!==-1) {
          this.orders[orderIndex].items[itemIndex].status = 2;
          this.orders[orderIndex].items[itemIndex].selected = false;
        }

        //CHECK IF ALL ITEMS IN PREPARATION
        const notPrepareItem = this.orders[orderIndex].items.find(
          (item) => item.status === 0 || item.status === 1
        );

        if (!notPrepareItem) {
          this.prepareAll(this.orders[orderIndex]);
        }
      }
    },
  },
  beforeMount() {
    if(process.env.VUE_APP_ANDROID_APP==='false'){
      this.$store.commit('setAuth',{
        bsid: new URL(location.href).searchParams.get("bsid"),
        bs: new URL(location.href).searchParams.get("bs"),
      })
    }
  },
  mounted() {
    if (this.bs === null || this.bsid === null) {
      if(process.env.VUE_APP_ANDROID_APP === 'false'){
        this.errorMessage = "Bitte überprüfe die URL";
      }
      return;
    }
    if(process.env.VUE_APP_ANDROID_APP === 'true'){
      this.$socket.io.uri = this.socketServer;
    }
    this.$socket.io.opts.query = {
      bs: this.bs,
      bsid: this.bsid,
      clientName: "Pickup_Monitor",
      userID: 0,
      clientType: 2
    };

    this.$socket.open();

    this.$socket.emit("pickupMonitor.refreshOrders");

    setInterval(()=>{
      let now = Date.now();
      for(let i=0;i<this.servedTimers.length;i++){
        if((now-this.servedTimers[i].time)>= 180000){ // checking the served order if it passes 3 mins
          this.removeOrder(this.servedTimers[i].order);
          this.servedTimers.splice(i,1);
          break;
        }
      }

    },10000)
  },
};
</script>
